import * as React from 'react'
import { ReactElement } from 'react'
import { Text, Toast, ToastBody, ToastTitle } from '@fluentui/react-components'
import { useTranslation } from 'react-i18next'
import ToastDismiss from './ToastDismiss'

export default function ReleaseMessageToastContent(): ReactElement {
    const { t: translate } = useTranslation()

    return (
        <Toast>
            <ToastTitle action={<ToastDismiss />}>{translate('base.warning.release_window.title')}</ToastTitle>
            <ToastBody>
                <Text>{translate('base.warning.release_window.description')}</Text>
            </ToastBody>
        </Toast>
    )
}
